import { removeHash } from '~/_shared/components/colorPicker/colorPicker.helpers';
import {
  HeatMapSample, HeatMapStyle, HeatMapType,
} from '~/_shared/types/heatmap/heatMap.enum';
import { type HeatMap } from '~/_shared/types/heatmap/heatMap.types';
import { createUuid } from '~/_shared/utils/createUuid';
import { type HeatMapPanelSubmitItem } from './panel/form/heatMapPanelForm.component';

export const createHeatMapFromForm = ({ item, colors, singleColor }: {
  colors: ReadonlyArray<string>;
  item: HeatMapPanelSubmitItem;
  singleColor: string;
}): HeatMap => {
  const id = createUuid();
  const commonProperties = {
    id,
    dissipate: true,
    unlinkFromOtherTools: false,
    isGradient: true,
    radius: 50,
    opacity: 50,
    threshold: 50,
    colors: colors.map(removeHash),
    singleColor: removeHash(singleColor),
  } as const;

  if (item.sample === HeatMapSample.SpecificGroup) {
    const groupCommon = {
      selectedGroupId: item.selectedGroupId || '',
      selectedGroupName: item.selectedGroupName || '',
      selectedGroupColumn: item.selectedGroupColumn,
      showMarkersForGroup: false,
    } as const;

    if (item.style === HeatMapStyle.MarkerDensity) {
      return {
        ...commonProperties,
        ...groupCommon,
        type: HeatMapType.GroupDensity,
        sample: HeatMapSample.SpecificGroup,
        style: HeatMapStyle.MarkerDensity,
      };
    }
    else {
      return {
        ...commonProperties,
        ...groupCommon,
        type: HeatMapType.GroupNumericalData,
        sample: HeatMapSample.SpecificGroup,
        style: HeatMapStyle.NumericalData,
        numericalColumnId: item.selectedNumericColumnId,
      };
    }
  }
  else {
    if (item.style === HeatMapStyle.MarkerDensity) {
      return {
        ...commonProperties,
        type: HeatMapType.AllMarkersDensity,
        sample: HeatMapSample.AllMarkers,
        style: HeatMapStyle.MarkerDensity,
      };
    }
    else {
      return {
        ...commonProperties,
        type: HeatMapType.AllMarkersNumericalData,
        sample: HeatMapSample.AllMarkers,
        style: HeatMapStyle.NumericalData,
        numericalColumnId: item.selectedNumericColumnId,
      };
    }
  }
};
